




































































import { uploadFilesToS3 } from '@/shareds/s3/files';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindImportacaoUseCase } from '@/usecases';
import { CashbackUseCase } from '@/usecases/cliente/CashbackUseCase';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DialogoDeCsvCashback extends Vue {
	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	]
	arquivoContemCabecalho = false
	importando = false
	exportando = false
	arquivoCsv: File[] = []
	cashbackUseCase = new CashbackUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()

	mostrar(){
		this.mostra = true
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	async concluirImportacao() {
		if (this.arquivoCsv.length == 0) {
			return AlertModule.setError("É obrigatório selecionar um arquivo");
		}

		if(!this.usuario) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.importando = false;
				return
			}
		}
	
		try {
			this.importando = true;

			const informacoesDosArquivos = await uploadFilesToS3(
				this.arquivoCsv,
				`importacao-cashback`,
			);
			const urlDoArquivo = informacoesDosArquivos.map(({ config }) => config.url)[0];

			if (!urlDoArquivo) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
			}

			await this.cashbackUseCase.importarCashback(
				this.arquivoContemCabecalho,
				urlDoArquivo,
			);

			AlertModule.setSuccess('Cashbacks em processamento');
			this.$emit('concluiuImportacao');
		} catch (e) {
			this.importando = false;
			AlertModule.setError(e);
		} finally {
			this.importando = false;
			this.arquivoCsv = [];
			this.mostra = false;
			this.arquivoContemCabecalho = false;
		}
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = []
		this.arquivoContemCabecalho = false
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}
}
